import { FlatItem } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/additional-types';

export const getAdditionalTypesDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
